import React, {
    useState,
    useEffect,
    useMemo,
    useContext
} from "react";

import { useParams } from "react-router-dom";

import { JWT } from "../../constants/local-storage";

import useFloorplanData
    from "./hooks/useFloorplanData";

import FloorSvg
    from "./components/FloorSvg";

import TimelinePlayer
    from "./components/TimelinePlayer";

import UtilisationIndicator
    from "./components/UtilisationIndicator";

import KpiPanel
    from "./components/KpiPanel";

import Header
    from "../../components/Header";

import LeftMenu
    from "../../components/LeftMenu";

import FloorplanModeToolbar
    from "./components/FloorplanModeToolbar";

import { COLOR_DASHBOARD_BACKGROUND }
    from "../../constants/colors";

import DeskPopup
    from "./components/DeskPopup";

import ActivityLegend
    from "./components/ActivityLegend";

import SelectionLegend
    from "../../components/SelectionLegend";

import { functions }
    from "../../constants/common-functions";

import { store }
    from "../../context/store.js";

import OrganisationExtremePanel
    from "./components/OrganisationExtremePanel";
	
	
import TitleGlassPill from "../../components/TitleGlassPill";


import {NAV_GRADIENT} from "../../constants/colors";
import {DRAWER_GRADIENT} from "../../constants/colors";


function formatTimestampUK(ts) {

    if (!ts) {
        return "";
    }
	
	
	

    const parts =
        ts.split(" ");

    const datePart =
        parts[0];

    const timePart =
        parts[1];

    const dateBits =
        datePart.split("-");

    const year =
        dateBits[0];

    const month =
        dateBits[1];

    const day =
        dateBits[2];

    const d =
        new Date(
            year
            + "-"
            + month
            + "-"
            + day
            + "T"
            + timePart
            + ":00"
        );

    const dayNames = [
        "Sun",
        "Mon",
        "Tue",
        "Wed",
        "Thu",
        "Fri",
        "Sat"
    ];

    const ukDate =
        day
        + "/"
        + month
        + "/"
        + year;

    const dow =
        dayNames[d.getDay()];

    return (
        dow
        + " "
        + ukDate
        + " — "
        + timePart
    );
}

function FloorplanUtilisationPage() {
	

    const [mode, setMode] =
        useState("intensity");

    const [currentFrame, setCurrentFrame] =
        useState(null);

    const [previousFrame, setPreviousFrame] =
        useState(null);

    const [currentTimestamp, setCurrentTimestamp] =
        useState("");

    const [selectedDesk, setSelectedDesk] =
        useState(null);

    const [floorName, setFloorName] =
        useState("");

    const [floorImage, setFloorImage] =
        useState("");

    const [floorWidth, setFloorWidth] =
        useState(0);

    const [floorHeight, setFloorHeight] =
        useState(0);

    const [selectedOrganisationIds, setSelectedOrganisationIds] =
        useState([]);

    const [allOrganisations, setAllOrganisations] =
        useState([]);
		
	const [isAnimationMode, setIsAnimationMode] =
		   useState(false);

    const globalState =
        useContext(store);

    const client =
        globalState
        && globalState.state
            ? globalState.state.client
            : null;
			
			
			
	const resourceRoot =
		    client != null &&
		    client.resourceFolderUrl != null
		        ? client.resourceFolderUrl
		        : "/resolutionclientdata";

    const { floorId } =
        useParams();

    const {
        desks,
        data,
        loading,
        intensityMap,
        timelineFrames,
        activities,
        organisations
    } =
        useFloorplanData(
            floorId,
            selectedOrganisationIds
        );

		/*     * ANIMATE TO FRAME     */
		function animateToFrame(targetFrame) {

		    if (
		        !targetFrame
		        || !timelineFrames
		        || timelineFrames.length === 0
		    ) {
		        return;
		    }

		    /*
		     * CURRENT INDEX
		     */
		    let startIndex = 0;

		    if (
		        currentFrame
		        && currentFrame.index != null
		    ) {
		        startIndex =
		            currentFrame.index;
		    }

		    /*
		     * TARGET INDEX
		     */
		    const targetIndex =
		        targetFrame.index;

		    /*
		     * ALREADY THERE
		     */
		    if (startIndex === targetIndex) {

		        setCurrentFrame(
		            targetFrame
		        );

		        setCurrentTimestamp(
		            targetFrame.date
		            + " "
		            + targetFrame.startTime
		            + " — "
		            + targetFrame.endTime
		        );

		        return;
		    }

		    /*
		     * START ANIMATION
		     */
		    setIsAnimationMode(true);

		    /*
		     * STOP EXISTING
		     */
		    if (window.fakeAnimationInterval) {

		        clearInterval(
		            window.fakeAnimationInterval
		        );
		    }

		    /*
		     * DIRECTION
		     */
		    const direction =
		        targetIndex > startIndex
		            ? 1
		            : -1;

		    /*
		     * DISTANCE
		     */
		    const distance =
		        Math.abs(
		            targetIndex - startIndex
		        );

		    /*
		     * STEP SIZE
		     */
		    let stepSize = 1;

		    if (distance > 100) {

		        stepSize = 8;
		    }
		    else if (distance > 50) {

		        stepSize = 5;
		    }
		    else if (distance > 25) {

		        stepSize = 3;
		    }
		    else if (distance > 10) {

		        stepSize = 2;
		    }

		    /*
		     * WORKING INDEX
		     */
		    let currentIndex =
		        startIndex;

		    /*
		     * STEP THROUGH FRAMES
		     */
		    window.fakeAnimationInterval =
		        setInterval(function () {

		            /*
		             * MOVE
		             */
		            currentIndex =
		                currentIndex
		                + (direction * stepSize);

		            /*
		             * CLAMP OVERSHOOT
		             */
		            if (
		                direction > 0
		                && currentIndex > targetIndex
		            ) {
		                currentIndex =
		                    targetIndex;
		            }

		            if (
		                direction < 0
		                && currentIndex < targetIndex
		            ) {
		                currentIndex =
		                    targetIndex;
		            }

		            /*
		             * SAFETY
		             */
		            if (
		                currentIndex < 0
		                || currentIndex >= timelineFrames.length
		            ) {

		                clearInterval(
		                    window.fakeAnimationInterval
		                );

		                setIsAnimationMode(false);

		                return;
		            }

		            /*
		             * NEXT FRAME
		             */
		            const nextFrame =
		                timelineFrames[currentIndex];

		            if (!nextFrame) {

		                clearInterval(
		                    window.fakeAnimationInterval
		                );

		                setIsAnimationMode(false);

		                return;
		            }

		            /*
		             * UPDATE FRAME
		             */
		            setPreviousFrame(
		                currentFrame
		            );

		            setCurrentFrame(
		                nextFrame
		            );

		            setCurrentTimestamp(
		                nextFrame.date
		                + " "
		                + nextFrame.startTime
		                + " — "
		                + nextFrame.endTime
		            );

		            /*
		             * FINISHED
		             */
		            if (currentIndex === targetIndex) {

		                clearInterval(
		                    window.fakeAnimationInterval
		                );

		                setIsAnimationMode(false);
		            }

		        }, 35);
		}

    /*
     * CHART CLICK
     */
	function handleChartFrameSelect(data) {

	    console.log(
	        "FRAME SELECT DATA",
	        data
	    );

	    if (
	        !timelineFrames
	        || timelineFrames.length === 0
	        || !data
	        || !data.date
	    ) {
	        return;
	    }

	    /*
	     * CLICKED DATE
	     */
	    const clickedDate =
	        data.date;

	    /*
	     * FORMAT YYYY-MM-DD
	     */
	    const year =
	        clickedDate.getFullYear();

	    const month =
	        String(
	            clickedDate.getMonth() + 1
	        ).padStart(2, "0");

	    const day =
	        String(
	            clickedDate.getDate()
	        ).padStart(2, "0");

	    const dateString =
	        year
	        + "-"
	        + month
	        + "-"
	        + day;

	    /*
	     * HOUR
	     */
	    const hour =
	        clickedDate.getHours();

	    console.log(
	        "MATCHING:",
	        dateString,
	        hour
	    );

	    /*
	     * FIND FRAME
	     */
	    const matchingFrame =
	        timelineFrames.find(function (f) {

	            const frameHour =
	                parseInt(
	                    f.startTime.split(":")[0]
	                );

	            return (
	                f.date === dateString
	                && frameHour === hour
	            );
	        });

	    console.log(
	        "MATCHED FRAME:",
	        matchingFrame
	    );

	    if (!matchingFrame) {
	        return;
	    }

	    /*
	     * ANIMATE
	     */
	    animateToFrame(
	        matchingFrame
	    );
	}

    useEffect(function () {

        if (
            organisations.length > 0
            && selectedOrganisationIds.length === 0
        ) {

            setSelectedOrganisationIds(
                organisations.map(function (o) {

                    return o.id;
                })
            );
        }

    }, [organisations]);

    useEffect(function () {

        if (!floorId) {
            return;
        }

        functions.getArrayFromAjax(
            "/resolutionsoftwareplatform/dashboard/utilisation/floorplan/organisations"
            + "?floorId="
            + floorId,

            function (rows) {
				console.log("ORGS", rows)
                setAllOrganisations(
                    rows || []
                );
            }
        );

    }, [floorId]);

    const activeOrganisationIds =
        useMemo(function () {

            return organisations.map(function (o) {

                return o.id;
            });

        }, [organisations]);

    useEffect(function () {

        if (
            !client
            || !client.resourceFolderUrl
            || !floorId
        ) {
            return;
        }

        const token =
            localStorage.getItem(JWT);

        fetch(
            "/resolutionsoftwareplatform/dashboard/utilisation/floorplan/floor?floorId="
            + floorId,
            {
                headers: {
                    Authorization:
                        "Bearer "
                        + token
                },
                credentials:
                    "include"
            }
        )
        .then(function (res) {

            if (!res.ok) {

                throw new Error(
                    "Floor fetch failed "
                    + res.status
                );
            }

            return res.json();
        })
        .then(function (floor) {

            setFloorName(
                floor.name
            );

            setFloorWidth(
                floor.floorplanImageWidthPx
            );

            setFloorHeight(
                floor.floorplanImageHeightPx
            );

            var code =
                floor.code;

            var facilityCode =
                floor.facilityCode;

            var imagePathJpg =
				resourceRoot +
                "/clientfloorplans/"
                + client.code
                + "/FLOORPLANS/"
                + facilityCode
                + "/"
                + code
                + ".jpg";

            var imagePathPng =
				resourceRoot +
                "/clientfloorplans/"
                + client.code
                + "/FLOORPLANS/"
                + facilityCode
                + "/"
                + code
                + ".png";

            var img =
                new Image();

            img.onload =
                function () {

                    setFloorImage(
                        imagePathJpg
                    );
                };

            img.onerror =
                function () {

                    setFloorImage(
                        imagePathPng
                    );
                };

            img.src =
                imagePathJpg;
        })
        .catch(function (err) {

            console.error(
                "Overall Error:"
                + err
            );
        });

    }, [floorId, client]);

    function resetToSurveyAverage() {

        setPreviousFrame(null);

        setCurrentFrame(null);

        setCurrentTimestamp("");

        setSelectedDesk(null);
    }

    const activityList =
        useMemo(function () {

            return activities.map(function (a) {

                return {
                    id: a.id,
                    name: a.name,
                    color: a.color
                };
            });

        }, [activities]);

    const organisationList =
        useMemo(function () {

            return organisations.map(function (o) {

                return {
                    id: o.id,
                    name: o.name,
                    color: o.color
                };
            });

        }, [organisations]);

    const kpiData =
        useMemo(function () {

            return data;

        }, [data]);

    const mainContainer = {

        display: "flex",
        position: "fixed",
        top: "0px",
        left: "60px",
        bottom: "0px",
        right: "0px",
        flexDirection: "row",
        overflow: "hidden",
        backgroundColor: "#f4f6f9"
    };

    const bottomBar = {

        position: "absolute",
        bottom: "20px",
        left: "20px",
        right: "20px",
        display: "flex",
        flexDirection: "row",
        alignItems: "center",
        zIndex: 50,
        pointerEvents: "auto"
    };

    const timestampStyle = {

        position: "fixed",
        top: "100px",
        left: "80px",
        padding: "8px 20px",
        background: "rgba(0,0,0,0.55)",
        color: "white",
        fontSize: "18px",
        borderRadius: "12px",
        boxShadow: "0 4px 12px rgba(0,0,0,0.3)",
        fontWeight: "500",
        zIndex: 50000
    };
	
	const floorHeader = {
	    display:
	        "flex",

	    position:
	        "fixed",

	    width:
	        "580px",

	    left:
	        "calc(50% - 290px)",

	    top:
	        "0px",

	    zIndex:
	        30000,

	    justifyContent:
	        "center",

	    alignItems:
	        "center",

	    height:
	        "50px",

	    color:
	        "rgba(255,255,255,0.84)",

	    background:
	        "linear-gradient(180deg,#171b20 0%,#0c0f12 100%)",

	    borderRadius:
	        "0px",

	    borderBottom:
	        "2px solid #20afe8",

	    boxShadow:
	        "0 8px 20px rgba(0,0,0,0.20)"
	};

	const floorHeaderTitle = {
	    display:
	        "flex",

	    alignItems:
	        "center",

	    justifyContent:
	        "center",

	    fontSize:
	        "16px",

	    fontWeight:
	        400,

	    letterSpacing:
	        "0.1px",

	    color:
	        "rgba(255,255,255,0.82)"
	};
	
	
	const kpiSectionGlass = {
	    background:
	        "linear-gradient(160deg, rgba(8,14,22,0.70), rgba(8,14,22,0.82))",

	    border:
	        "1px solid rgba(141,200,240,0.12)",

	    borderRadius: "10px",

	    boxShadow:
	        "0 8px 24px rgba(0,0,0,0.20)",

	    padding: "14px",

	    marginBottom: "14px"
	};

    return (

        <div style={{overflow:'hidden'}}>

            <Header transitionHide={true} showSurveySelector = {true}/>

            <LeftMenu />

            <div style={mainContainer}>

                {/* LEFT AREA */}

                <div
                    style={{
                        padding: "0px",
                        height: "100%",
                        overflow: "hidden",
                        display: "flex",
                        flexDirection: "column",
                        position: "relative",
                        width: "calc(100% - 400px)"
                    }}
                >

                    <div
                        style={{
                            padding: "0px",
                            margin: "0px",
                            borderRadius: "0px",
                            background: "white",
                            border: "1px solid #EEF1F5",
                            boxShadow: "0 1px 2px rgba(0,0,0,0.04)",
                            position: "relative",
                            overflow: "hidden"
                        }}
                    >

                        <FloorSvg
                            selectedDesk={selectedDesk}
                            setSelectedDesk={setSelectedDesk}
                            data={data}
                            desks={desks}
                            mode={mode}
                            intensityMap={intensityMap}
                            frame={currentFrame}
                            prevFrame={previousFrame}
                            activities={activities}
                            organisations={organisations}
                            floorImage={floorImage}
                            floorWidth={floorWidth}
                            floorHeight={floorHeight}
                        />

                    </div>

                    {/* BOTTOM TOOLBAR */}

                    <div style={bottomBar}>

                        <FloorplanModeToolbar
                            mode={mode}
                            setMode={setMode}
                        />

                        <div style={{ width: "20px" }} />

						<TimelinePlayer
						    frames={timelineFrames}
						    onFrameChange={function (frame) {

						        /*
						         * IGNORE TIMELINE EVENTS
						         * DURING CHART ANIMATION
						         */
								

						        setPreviousFrame(
						            currentFrame
						        );

						        setCurrentFrame(
						            frame
						        );

						        setCurrentTimestamp(
						            (frame.date || "")
						            + " "
						            + (frame.startTime || "")
						            + " — "
						            + (frame.endTime || "")
						        );
						    }}
						    onReset={resetToSurveyAverage}
							isAnimationMode={isAnimationMode}
							setIsAnimationMode={setIsAnimationMode}
							currentFrame={currentFrame}
						/>

                    </div>

                </div>

				{/* RIGHT KPI PANEL */}

				<div
				    style={{
				        width: "420px",
				        flexShrink: 0,

				        backgroundImage: `
				            linear-gradient(
				                160deg,
				                rgba(19,25,32,0.68) 0%,
				                rgba(9,17,26,0.68) 100%
				            ),
				            url("/website/images/banner1.jpg")
				        `,

				        backgroundSize: "cover",
				        backgroundPosition: "center",
				        backgroundRepeat: "no-repeat",

				        padding: "20px 24px 30px 24px",

				        display: "flex",
				        flexDirection: "column",

				        overflowY: "hidden",

				        borderLeft:
				            "1px solid rgba(141,200,240,0.24)",

				        boxShadow:
				            "-8px 0 28px rgba(0,0,0,0.35)"
				    }}
				>
					<div style={kpiSectionGlass}>
				    	<KpiPanel data={kpiData} />
					</div>
				</div>

            </div>

            {/* TIMESTAMP */}

            {currentTimestamp && (

                <div style={timestampStyle}>

                    {currentTimestamp}

                </div>
            )}

            {/* ACTIVITY LEGEND */}

            {mode === "activity"
                && activityList.length > 0
                && (

                <div
                    style={{
                        position: "fixed",
                        top: "156px",
                        left: "80px",
                        padding: "12px 18px",
                        background: "white",
                        borderRadius: "12px",
                        border: "1px solid #e5e5e5",
                        boxShadow:
                            "0 4px 12px rgba(0,0,0,0.15)",
                        zIndex: 60000
                    }}
                >

                    <div
                        style={{
                            fontWeight: "600",
                            marginBottom: "8px"
                        }}
                    >
                        Activity Key
                    </div>

                    {activityList.map(function (a) {

                        return (

                            <div
                                key={a.id}
                                style={{
                                    display: "flex",
                                    alignItems: "center",
                                    marginBottom: "6px"
                                }}
                            >

                                <div
                                    style={{
                                        width: "16px",
                                        height: "16px",
                                        borderRadius: "4px",
                                        background: a.color,
                                        marginRight: "8px"
                                    }}
                                />

                                <div style={{ fontSize: "12px" }}>
                                    {a.name}
                                </div>

                            </div>
                        );
                    })}

                </div>
            )}

            {/* ORG LEGEND */}

            {mode === "organisation"
                && organisationList.length > 0
                && (

                <SelectionLegend
                    title="Organisation Filter"
                    items={allOrganisations}
                    selectedIds={selectedOrganisationIds}
                    activeIds={activeOrganisationIds}
                    onSelectionChange={setSelectedOrganisationIds}
                />
            )}

            {/* DESK POPUP */}

            {selectedDesk && (

                <DeskPopup
                    desk={selectedDesk}
                    onClose={function () {

                        setSelectedDesk(null);
                    }}
                />
            )}

            {/* FLOOR TITLE */}

			<div style={floorHeader}>
			    <div style={floorHeaderTitle}>
			        {floorName}
			    </div>
			</div>

           

			{/* RIGHT ORG DRAWER */}
			<div
			    style={{
			        position: "fixed",

			        top: "0px",
			        right: "0px",
			        bottom: "0px",

			        width: "470px",
			        boxSizing: "border-box",

			        backgroundImage: `
			            linear-gradient(
			                160deg,
			                rgba(19,25,32,0.68) 0%,
			                rgba(9,17,26,0.68) 100%
			            ),
			            url("/website/images/banner1.jpg")
			        `,

			        backgroundSize: "cover",
			        backgroundPosition: "center",
			        backgroundRepeat: "no-repeat",

			        padding: "20px 24px 30px 24px",

			        display: "flex",
			        flexDirection: "column",

			        overflowY: "auto",
			        overflowX: "hidden",

			        borderLeft:
			            "1px solid rgba(141,200,240,0.24)",

			        boxShadow:
			            "-8px 0 28px rgba(0,0,0,0.35)",

			        zIndex: 1000,

			        transform:
			            mode === "organisation"
			                ? "translateX(0)"
			                : "translateX(100%)",

			        transition:
			            "transform 350ms cubic-bezier(0.4, 0, 0.2, 1)",

			        visibility:
			            mode === "organisation"
			                ? "visible"
			                : "hidden",

			        pointerEvents:
			            mode === "organisation"
			                ? "auto"
			                : "none"
			    }}
			>
			    <div style={kpiSectionGlass}>

			        <OrganisationExtremePanel
			            organisationIds={selectedOrganisationIds}
			            organisations={allOrganisations}
			            timelineFrames={timelineFrames}
			            currentFrame={currentFrame}
			            onFrameSelect={handleChartFrameSelect}
			            desks={desks}
			            isAnimationMode={isAnimationMode}
			        />

			    </div>
			</div>

        </div>
    );
}

export default FloorplanUtilisationPage;